export default "__VITE_ASSET__BLzcSjTY__"